import { gql } from '@apollo/client';

import { threadAnswerFragment } from '../fragments';

export default gql`
  query GetThreadAnswers(
    $courseId: String
    $threadId: String!
    $answerId: String!
  ) {
    threadAnswer(courseId: $courseId, threadId: $threadId, answerId: $answerId)
      @rest(
        type: "ThreadAnswer"
        path: "/courses/{args.courseId}/threads/{args.threadId}/answers/{args.answerId}"
      ) {
      ...ThreadAnswer
    }
  }
  ${threadAnswerFragment}
`;
